import IntroductionContainer from './introduction'

export default IntroductionContainer